document.addEventListener("DOMContentLoaded", () => {
  const viewInRoomButton = document.querySelector(".view-in-room-button");

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isAndroid = /android/i.test(navigator.userAgent);
  const isChrome = /chrome/i.test(navigator.userAgent);

  viewInRoomButton?.addEventListener("click", (e) => {
    e.preventDefault();

    if (!(isIOS && isSafari) || (isAndroid && isChrome)) {

      window.alert(
        "Please use Safari on iPhone or Chrome on Android to view the 3D model."
      );
    } else {
      window.ShopifyXR.launchXR({
        model3dId: viewInRoomButton.dataset.modelId,
        title: "{{ product.title | escape }}",
      });
    }
  });
});